/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useInternalTeamsGet = makeQueryHook(operations.internalTeamsGet)

export const useInternalTeamsCreate = makeMutationHook(
  operations.internalTeamsCreate,
)

export const useInternalTeamGet = makeQueryHook(operations.internalTeamGet)

export const useInternalTeamUpdate = makeMutationHook(
  operations.internalTeamUpdate,
)

export const useInternalTeamDelete = makeMutationHook(
  operations.internalTeamDelete,
)

export const useInternalEmployeesGet = makeQueryHook(
  operations.internalEmployeesGet,
)

export const useInternalEmployeeCreate = makeMutationHook(
  operations.internalEmployeeCreate,
)

export const useInternalEmployeeGetById = makeQueryHook(
  operations.internalEmployeeGetById,
)

export const useInternalEmployeeUpdate = makeMutationHook(
  operations.internalEmployeeUpdate,
)

export const useInternalSyncTwilioWorkerByEmployeeId = makeMutationHook(
  operations.internalSyncTwilioWorkerByEmployeeId,
)

export const useInternalEmployeeAddToTeam = makeMutationHook(
  operations.internalEmployeeAddToTeam,
)

export const useInternalEmployeeRemoveFromTeam = makeMutationHook(
  operations.internalEmployeeRemoveFromTeam,
)

export const useTeamsGet = makeQueryHook(operations.teamsGet)

export const useTeamsCreate = makeMutationHook(operations.teamsCreate)

export const useTeamGet = makeQueryHook(operations.teamGet)

export const useTeamUpdate = makeMutationHook(operations.teamUpdate)

export const useTeamDelete = makeMutationHook(operations.teamDelete)

export const useEmployeesGet = makeQueryHook(operations.employeesGet)

export const useEmployeeCreate = makeMutationHook(operations.employeeCreate)

export const useEmployeeGetById = makeQueryHook(operations.employeeGetById)

export const useEmployeeUpdate = makeMutationHook(operations.employeeUpdate)

export const useEmployeeEmailSignatureGet = makeQueryHook(
  operations.employeeEmailSignatureGet,
)

export const useEmployeeEmailSignatureSet = makeMutationHook(
  operations.employeeEmailSignatureSet,
)

export const useEmployeeAddToTeam = makeMutationHook(
  operations.employeeAddToTeam,
)

export const useEmployeeRemoveFromTeam = makeMutationHook(
  operations.employeeRemoveFromTeam,
)

export const useInternalGetEmployeeAssignedInvestors = makeQueryHook(
  operations.internalGetEmployeeAssignedInvestors,
)

export const useInternalEmployeeAssignInvestor = makeMutationHook(
  operations.internalEmployeeAssignInvestor,
)

export const useInternalEmployeeUnassignInvestor = makeMutationHook(
  operations.internalEmployeeUnassignInvestor,
)
